import React, { Fragment, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import PlayCircleOutlineOutlinedIcon from "@material-ui/icons/PlayCircleOutlineOutlined";
import MediaCarouselDialog from "./MediaCarouselDialog";
import { Media } from "../models/Media";

const CustomVideoPlayer = ({
  style,
  backgroundColor,
  className,
  onClick,
  src,
  enablePreview = false,
}) => {
  const classes = makeStyles((theme) => ({
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 10,
      backgroundColor: backgroundColor ?? theme.palette.background.paper,
    },
    video: {
      height: "100%",
      width: "100%",
      background: "none center center no-repeat black",
    },
  }))();

  const [openPreview, setOpenPreview] = useState(false);

  const handlePreview = () => {
    setOpenPreview(true);
  };

  return (
    <Fragment>
      <Box
        className={clsx(className, classes.container)}
        style={
          enablePreview || onClick ? { cursor: "pointer", ...style } : style
        }
        onClick={onClick ?? handlePreview}
      >
        {!enablePreview ? (
          <video
            className={classes.video}
            autoPlay={true}
            controls
            preload="auto"
          >
            <source src={src} />
          </video>
        ) : (
          <PlayCircleOutlineOutlinedIcon fontSize="large" />
        )}
      </Box>

      <MediaCarouselDialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        media={[Media.fromValues(src, Media.types.video)]}
      />
    </Fragment>
  );
};

export default CustomVideoPlayer;
